/* =============================================================================
   RIDBOI MONOCHROME — THEME INTERACTIONS (Shopify build)
   Header scroll state · mobile nav drawer · reveal-on-scroll · announcement ·
   hero slideshow · help widget. Plain JS, no dependencies.
   ============================================================================ */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

  /* --- 01. Sticky header ---
     The whole header group (menu + black announcement bar) stays pinned at the
     top at all times (#stickyHead is sticky). This just toggles the scrolled
     shadow; the menu never hides. */
  (function () {
    var wrap = document.getElementById('stickyHead');
    var header = document.getElementById('header');
    if (!header) return;
    if (wrap) wrap.classList.remove('is-nav-hidden');
    var ticking = false;
    function update() { header.classList.toggle('is-scrolled', window.scrollY > 24); ticking = false; }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();

  /* --- 01b. Size guide modal (per-product image) --- */
  (function () {
    var openBtn = document.getElementById('sizeGuideOpen');
    var modal = document.getElementById('sizeGuideModal');
    var backdrop = document.getElementById('sizeGuideBackdrop');
    var closeBtn = document.getElementById('sizeGuideClose');

    /* cm / inches toggle: both values are already in the cell, we only swap
       which one is visible, so there is no rounding to get wrong */
    document.addEventListener('click', function (e) {
      var u = e.target.closest('[data-unit-btn]');
      if (!u) return;
      var chart = u.closest('[data-size-chart]');
      if (!chart) return;
      chart.setAttribute('data-unit', u.getAttribute('data-unit-btn'));
      chart.querySelectorAll('[data-unit-btn]').forEach(function (b) {
        b.classList.toggle('is-active', b === u);
      });
      flagScroll(chart);
    });

    /* Only hint at horizontal scroll when the table really is wider than
       its box, which depends on the unit and the phone. */
    function flagScroll(scope) {
      (scope || document).querySelectorAll('.sg-tablewrap').forEach(function (w) {
        w.classList.toggle('is-scrollable', w.scrollWidth > w.clientWidth + 1);
      });
    }
    window.addEventListener('resize', function () { flagScroll(); });
    if (openBtn) openBtn.addEventListener('click', function () { setTimeout(flagScroll, 60); });
    if (!openBtn || !modal || !backdrop) return;

    function open() {
      backdrop.removeAttribute('hidden');
      requestAnimationFrame(function () { backdrop.classList.add('is-open'); });
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      backdrop.classList.remove('is-open');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      setTimeout(function () { backdrop.setAttribute('hidden', ''); }, 260);
      document.body.style.overflow = '';
      openBtn.focus();
    }
    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  })();

  /* --- 01a. Collection grid: shuffled order ---
     Shopify has no "random" sort, so we shuffle in the browser. The seed is
     kept for the session, so the order stays put while someone browses and
     hits back, instead of reshuffling under them on every page view. */
  (function () {
    var grid = document.querySelector('[data-shuffle-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.children);
    if (cards.length < 3) return;

    var seed;
    try { seed = sessionStorage.getItem('rbc_shuffle'); } catch (e) {}
    if (!seed) {
      seed = String(Math.floor(Math.random() * 1e9));
      try { sessionStorage.setItem('rbc_shuffle', seed); } catch (e) {}
    }
    /* page number folded into the seed so each page shuffles differently */
    var page = (location.search.match(/[?&]page=(\d+)/) || [null, '1'])[1];
    var s = (parseInt(seed, 10) || 1) + parseInt(page, 10) * 7919;

    function rnd() {                       // deterministic PRNG from the seed
      s = (s * 1664525 + 1013904223) % 4294967296;
      return s / 4294967296;
    }
    for (var i = cards.length - 1; i > 0; i--) {   // Fisher-Yates
      var j = Math.floor(rnd() * (i + 1));
      var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
    }
    var frag = document.createDocumentFragment();
    cards.forEach(function (c) { frag.appendChild(c); });
    grid.appendChild(frag);
  })();

  /* --- 01b. Rails (homepage rows, Handpicked): a balanced random mix ---
     The section renders a wide pool and this keeps N cards. Men's and women's
     alternate, because 48 of the 70 pieces are men's and a plain random pick
     would be mostly menswear. A piece one row already shows goes to the back
     of the queue for the next row. Seeded per session like the grid, so
     pressing back from a product doesn't reshuffle the page. */
  (function () {
    var rails = Array.prototype.slice.call(document.querySelectorAll('[data-rail-mix]'));
    if (!rails.length) return;
    var seed;
    try { seed = sessionStorage.getItem('rbc_shuffle'); } catch (e) {}
    if (!seed) {
      seed = String(Math.floor(Math.random() * 1e9));
      try { sessionStorage.setItem('rbc_shuffle', seed); } catch (e) {}
    }
    var s = (parseInt(seed, 10) || 1) + location.pathname.length * 104729;
    function rnd() { s = (s * 1664525 + 1013904223) % 4294967296; return s / 4294967296; }
    function shuffle(a) {
      for (var i = a.length - 1; i > 0; i--) {
        var j = Math.floor(rnd() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t;
      }
      return a;
    }
    function cardOf(el) { return el.matches('[data-pc-card]') ? el : el.querySelector('[data-pc-card]'); }
    function gender(el) { var c = cardOf(el); return (c && c.getAttribute('data-gender')) || 'other'; }
    function handle(el) { var c = cardOf(el); return (c && c.getAttribute('data-handle')) || ''; }

    var used = {};
    rails.forEach(function (rail) {
      var keep = parseInt(rail.getAttribute('data-rail-mix'), 10) || 8;
      var items = Array.prototype.slice.call(rail.children);
      if (items.length < 2) return;

      var buckets = { women: [], men: [], other: [] };
      shuffle(items.slice()).forEach(function (el) { (buckets[gender(el)] || buckets.other).push(el); });
      Object.keys(buckets).forEach(function (k) {       // unseen pieces first
        buckets[k].sort(function (a, b) { return (used[handle(a)] ? 1 : 0) - (used[handle(b)] ? 1 : 0); });
      });

      var order = rnd() < 0.5 ? ['women', 'men'] : ['men', 'women'];
      var picked = [], turn = 0;
      while (picked.length < keep && (buckets.women.length || buckets.men.length)) {
        var b = buckets[order[turn % 2]];
        if (b.length) picked.push(b.shift());
        turn++;
      }
      while (picked.length < keep && buckets.other.length) picked.push(buckets.other.shift());

      items.forEach(function (el) { if (picked.indexOf(el) < 0) el.parentNode.removeChild(el); });
      var frag = document.createDocumentFragment();
      picked.forEach(function (el, i) {
        used[handle(el)] = 1;
        var c = cardOf(el);
        if (c) c.style.setProperty('--reveal-delay', (i * 80) + 'ms');
        frag.appendChild(el);
      });
      rail.appendChild(frag);
    });
  })();

  /* --- 01c. Product cards: swipe through colours + working colour dots ---
     Each slide is one colourway, so swiping cycles colours and every swatch
     has a slide to land on. Inside horizontal rails the photos still change on
     their own, but the card never takes the swipe: a finger on a rail always
     moves to the next product. Auto-advance is STAGGERED per card so nothing
     flips in unison. In the grid it stops for good once a card is touched; in
     a rail only a colour-dot tap stops it, since touching there means scrolling. */
  (function () {
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-pc-card]'));
    if (!cards.length) return;

    var AUTO_MS = 5000;
    var autoAllowed = !prefersReducedMotion &&
                      document.body.getAttribute('data-card-autoplay') !== 'off';

    cards.forEach(function (card, cardIndex) {
      var slider = card.querySelector('[data-pc-slider]');
      if (!slider) return;
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.pc-slide'));
      var dotWrap = card.querySelector('[data-pc-dots]');
      var rail = !!card.closest('.product-grid--slider, .rec-slider');
      var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-pc-swatch]'));
      var touched = false, timer = null, raf = null;

      if (slides.length < 2) { if (dotWrap) dotWrap.remove(); return; }

      /* dots are built here so they always match the real slide count */
      var dots = [];
      if (dotWrap) {
        slides.forEach(function (_, i) {
          var d = document.createElement('span');
          d.className = 'pc-dot' + (i === 0 ? ' is-on' : '');
          dotWrap.appendChild(d);
          dots.push(d);
        });
      }

      function index() {
        var w = slider.clientWidth || 1;
        return Math.min(slides.length - 1, Math.round(slider.scrollLeft / w));
      }
      function paint() {
        var i = index();
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
        var colour = slides[i] && slides[i].getAttribute('data-colour');
        if (colour) {
          swatches.forEach(function (sw) {
            sw.classList.toggle('is-active', sw.getAttribute('data-value') === colour);
          });
        }
      }
      function goTo(i) { slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' }); }

      slider.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(paint);
      }, { passive: true });

      if (!rail) {
        ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
          slider.addEventListener(ev, function () { touched = true; stop(); }, { passive: true });
        });
      }

      /* colour dot -> the slide for that colour */
      swatches.forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          touched = true; stop();
          var val = sw.getAttribute('data-value');
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].getAttribute('data-colour') === val) { goTo(i); break; }
          }
          swatches.forEach(function (o) { o.classList.toggle('is-active', o === sw); });
        });
      });

      function tick() {
        if (touched || !slider.clientWidth) return;
        goTo((index() + 1) % slides.length);
      }
      /* offset each card so the grid breathes instead of flipping in unison */
      var offset = (cardIndex % 7) * 780 + Math.floor(Math.random() * 500);
      function start() {
        if (timer || !autoAllowed || touched) return;
        timer = setTimeout(function () {
          if (touched) { timer = null; return; }
          tick();
          timer = setInterval(tick, AUTO_MS);
        }, offset);
      }
      function stop() {
        if (timer) { clearTimeout(timer); clearInterval(timer); timer = null; }
      }

      if (autoAllowed && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { en.isIntersecting ? start() : stop(); });
        }, { threshold: 0.55 }).observe(card);
      }

      paint();
    });
  })();

  /* --- 02. Mobile nav drawer (focus trap + esc + backdrop) --- */
  (function () {
    var toggle = document.getElementById('navToggle');
    var nav = document.getElementById('mobileNav');
    var backdrop = document.getElementById('navBackdrop');
    var closeBtn = document.getElementById('navClose');
    if (!toggle || !nav || !backdrop) return;
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      backdrop.hidden = false;
      requestAnimationFrame(function () { backdrop.classList.add('is-open'); });
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('nav-open');
      if (closeBtn) { closeBtn.focus(); } else { var first = nav.querySelector(FOCUSABLE); if (first) first.focus(); }
    }
    function close() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      backdrop.classList.remove('is-open');
      document.body.classList.remove('nav-open');
      setTimeout(function () { backdrop.hidden = true; }, 300);
      if (lastFocused) lastFocused.focus();
    }
    toggle.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
      if (e.key === 'Tab' && nav.classList.contains('is-open')) {
        var els = nav.querySelectorAll(FOCUSABLE);
        if (!els.length) return;
        var first = els[0], last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // "Cart" row inside the drawer: close nav, then open cart
    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cart-open]');
      if (btn) { close(); setTimeout(function () { document.dispatchEvent(new CustomEvent('rbc:cart:open')); }, 320); }
    });
  })();

  /* --- 03. Reveal on scroll --- */
  (function () {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;
    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    items.forEach(function (el) { observer.observe(el); });
    // Shopify theme editor: re-run when sections are re-rendered
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
    });
  })();

  /* --- 04. Announcement bar dismiss --- */
  (function () {
    var bar = document.getElementById('announceBar');
    var btn = document.getElementById('announceClose');
    if (!bar || !btn) return;
    try { if (sessionStorage.getItem('rbc_announce_dismissed')) bar.classList.add('is-dismissed'); } catch (e) {}
    btn.addEventListener('click', function () {
      bar.classList.add('is-dismissed');
      try { sessionStorage.setItem('rbc_announce_dismissed', '1'); } catch (e) {}
    });
  })();

  /* --- 05. Hero slideshow (blocks; arrows + swipe; pauses on interaction) --- */
  function initHeroSlideshow(root) {
    var stage = root.querySelector('[data-hero-slides]');
    if (!stage) return;
    var frame = stage.closest('.hero__frame') || root;
    var prevBtn = frame.querySelector('.hero__nav--prev');
    var nextBtn = frame.querySelector('.hero__nav--next');
    var DELAY = 1800;
    var idx = 0, timer = null;

    function slides() { return Array.prototype.slice.call(stage.querySelectorAll('.hero__slide')); }
    var dots = frame.querySelectorAll('[data-hero-dot]');
    function paint() {
      var list = slides();
      if (idx >= list.length) idx = 0;
      list.forEach(function (el, i) { el.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      var many = list.length > 1;
      if (prevBtn) prevBtn.hidden = !many;
      if (nextBtn) nextBtn.hidden = !many;
    }
    function go(step) {
      var list = slides();
      if (list.length < 2) return;
      idx = (idx + step + list.length) % list.length;
      paint();
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (prefersReducedMotion || slides().length < 2) return;
      timer = setInterval(function () { go(1); }, DELAY);
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); start(); });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { idx = i; paint(); start(); });
    });
    frame.addEventListener('mouseenter', stop);
    frame.addEventListener('mouseleave', start);
    frame.addEventListener('focusin', stop);
    frame.addEventListener('focusout', start);
    // Tap the image to change slides (left third = previous, rest = next).
    // Links, buttons and the headline/CTA block keep their own behaviour.
    frame.addEventListener('click', function (e) {
      if (slides().length < 2) return;
      if (e.target.closest('a, button, .hero__content')) return;
      var rect = frame.getBoundingClientRect();
      go(e.clientX - rect.left < rect.width / 3 ? -1 : 1);
      start();
    });
    var sx = 0, sy = 0, tracking = false;
    frame.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0]; sx = t.clientX; sy = t.clientY; tracking = true; stop();
    }, { passive: true });
    frame.addEventListener('touchend', function (e) {
      if (!tracking) return; tracking = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      start();
    }, { passive: true });
    paint(); start();
  }
  document.querySelectorAll('[data-hero]').forEach(initHeroSlideshow);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hero]').forEach(initHeroSlideshow);
  });

  /* --- 05b. Referral links (trainers: /?ref=tobi) ---
     Any name works, nothing to set up: the name is kept for 30 days and rides
     along with the cart, so the finished order shows "Referred by: Tobi" in
     admin and in the CSV export. Add-to-cart is NOT touched here, product.js
     owns that form; we only top the cart up on the way to checkout. */
  (function () {
    var KEY = 'rbc_ref', SENT = 'rbc_ref_sent', DAYS = 30;

    function clean(v) {
      return String(v || '').replace(/[^A-Za-z0-9 _-]/g, '').replace(/\s+/g, ' ').trim().slice(0, 40);
    }
    function save(v) {
      try { localStorage.setItem(KEY, JSON.stringify({ v: v, exp: Date.now() + DAYS * 864e5 })); } catch (e) {}
    }
    function held() {
      try {
        var r = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (r && r.v && r.exp > Date.now()) return r.v;
        if (r) localStorage.removeItem(KEY);
      } catch (e) {}
      return '';
    }
    function sent(v) { try { return sessionStorage.getItem(SENT) === v; } catch (e) { return false; } }
    function attach(v) {
      if (!v) return Promise.resolve();
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Referred by': v } })
      }).then(function () {
        try { sessionStorage.setItem(SENT, v); } catch (e) {}
      }).catch(function () {});
    }

    /* 1. arriving on a trainer's link */
    var fresh = '';
    try { fresh = clean(new URL(window.location.href).searchParams.get('ref')); } catch (e) {}
    if (fresh) {
      save(fresh);
      attach(fresh);
      try {                                   // tidy the address bar
        var u = new URL(window.location.href);
        u.searchParams.delete('ref');
        if (window.history.replaceState) window.history.replaceState({}, '', u.pathname + u.search + u.hash);
      } catch (e) {}
    } else {
      var v = held();
      if (v && !sent(v)) attach(v);
    }

    /* 2. after adding to the bag, in case the cart was rebuilt */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.product-form__buy, [data-add-to-cart]')) return;
      var v = held();
      if (v) setTimeout(function () { attach(v); }, 600);
    });

    /* The checkout form is left alone on purpose. Re-submitting it from script
       drops the submit button's own "checkout" value, and Shopify then just
       reloads the bag instead of going to checkout. The name is already on the
       cart by this point anyway, from the page load and the add to bag. */
  })();

  /* --- 06. Chat widget (WhatsApp funnel) ---
     Looks like a live chat: type a message, press send, and it opens WhatsApp
     with that message pre-filled. The launcher shows a "Chat with us" label
     that collapses to an icon once the page is scrolled. */
  (function () {
    var widget = document.getElementById('chatWidget');
    if (!widget) return;
    var launcher = document.getElementById('chatLauncher');
    var panel = document.getElementById('chatPanel');
    var closeBtn = document.getElementById('chatClose');
    var form = document.getElementById('chatForm');
    var input = document.getElementById('chatInput');
    var body = document.getElementById('chatBody');

    /* Build the wa.me link from the configured link, stripping any existing query. */
    var raw = widget.getAttribute('data-wa') || '';
    var digits = (raw.match(/\d+/g) || []).join('');
    function waLink(text) {
      var base = digits ? 'https://wa.me/' + digits : raw.split('?')[0];
      return base + '?text=' + encodeURIComponent(text);
    }

    function setOpen(open) {
      widget.classList.toggle('is-open', open);
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { setTimeout(function () { input.focus(); }, 160); }
    }

    launcher.addEventListener('click', function () { setOpen(!widget.classList.contains('is-open')); });
    if (closeBtn) closeBtn.addEventListener('click', function () { setOpen(false); launcher.focus(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && widget.classList.contains('is-open')) { setOpen(false); launcher.focus(); }
    });

    /* Show the typed message as an outgoing bubble, then hand off to WhatsApp. */
    function send(text) {
      text = (text || '').trim();
      if (!text) return;
      var msg = document.createElement('div');
      msg.className = 'chatw__msg chatw__msg--out';
      msg.innerHTML = '<p></p>';
      msg.querySelector('p').textContent = text;
      body.appendChild(msg);
      body.scrollTop = body.scrollHeight;
      input.value = '';
      window.open(waLink(text), '_blank', 'noopener');
    }

    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); send(input.value); });

    /* Quick-reply chips send immediately. */
    widget.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('.chatw__chip') : null;
      if (chip) send(chip.getAttribute('data-msg'));
    });

    /* Collapse the launcher label to an icon once the visitor scrolls. */
    var collapsed = false;
    function onScroll() {
      var should = window.scrollY > 90;
      if (should !== collapsed) { collapsed = should; widget.classList.toggle('is-collapsed', collapsed); }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ===========================================================================
     09. PARALLAX — background image drifts slower than the overlaid text as you
     scroll (lululemon-style depth). Transform-only + rAF; off for reduced motion.
     ========================================================================== */
  (function parallax() {
    if (prefersReducedMotion) return;
    var imgs = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    var texts = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-text]'));
    if (!imgs.length && !texts.length) return;

    var IMG_MAX = 82;   // px of image travel
    var TXT_MAX = 46;   // px of text travel (moves opposite → separation)
    var vh = window.innerHeight;
    var ticking = false;

    function hostRect(el) {
      var host = el.closest('.hero__frame, .feature__banner') || el.parentElement || el;
      return host.getBoundingClientRect();
    }
    function apply(el, max, invert) {
      var r = hostRect(el);
      if (r.bottom < -80 || r.top > vh + 80) return;                 // offscreen: skip
      var norm = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2); // ~ -1..1
      if (norm > 1) norm = 1; if (norm < -1) norm = -1;
      var offset = norm * max * (invert ? -1 : 1);
      el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    }
    function update() {
      ticking = false;
      for (var i = 0; i < imgs.length; i++) apply(imgs[i], parseFloat(imgs[i].getAttribute('data-parallax')) ? IMG_MAX : IMG_MAX, false);
      for (var j = 0; j < texts.length; j++) apply(texts[j], TXT_MAX, true);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { vh = window.innerHeight; update(); });
    // re-scan when Shopify editor re-renders a section
    document.addEventListener('shopify:section:load', function () {
      imgs = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
      texts = Array.prototype.slice.call(document.querySelectorAll('[data-parallax-text]'));
      update();
    });
    update();
  })();

})();
